export const getSpeed = (offerName) => {
  if (offerName.endsWith('kbps')) {
    const nameSplitted = offerName.split('_');
    return nameSplitted[nameSplitted.length - 1];
  } else {
    return 'Máxima velocidad';
  }
};
